import React, { useState } from 'react'

// query
import { useMutation } from '@apollo/client'
import { BULK_CREATE_SHIPPING_LOGS } from '../../../../../graphql/inventoryShippingLog/inventoryShippingLog.mutations'

// components
import SideViewModal from '../../../../../components/modals/SideViewModal/SideViewModal.component'

// utils
import { createSubmitData } from './ShippingLog.form.controller.utils'
import { validate } from '../../../../../shared/utility'

// collections
import ShippingForm from './Shipping.form'

const validationSchema = {
    toJob: {
        type: 'input',
        validation: {
            required: true
        }
    },
    date: {
        type: 'date',
        validation: {
            required: true,
            isDate: true
        }
    },
    time: {
        type: 'time',
        validation: {
            required: true,
            isTime: true
        }
    },
    truck: {
        type: 'input',
        validation: {
            required: true
        }
    },
    equipment: {
        type: 'list',
        fields: {
            quantity: {
                validation: {
                    required: true,
                    isNumeric: true,
                    maxAmountField: 'currentQty'
                }
            }
        }
    }
}

export default function ShippingLogFormController({ visible, closeForm}) {

    const [createShippingLogs, {}] = useMutation(BULK_CREATE_SHIPPING_LOGS)
    const [errors, setErrors] = useState({ equipment: []})
    const [submitError, setSubmitError] = useState(null)

    // handle the form submission
    const handleSubmit = (formData) => {

        let submitData = createSubmitData(formData)

        let { isValid, errors } = validate(formData, validationSchema)

        if(isValid) {
            createShippingLogs({ variables: {...submitData}, refetchQueries:[]}).catch(e => {
                setSubmitError(e.message)
            }).then(result => {
                if(result) {
                    setErrors({ equipment: []})
                    closeForm()
                }
            })
        } else {
            setErrors(errors)
        }
        
    }

    if(visible) {
        const variants = [
            {
                name: 'Shipping',
                component: <ShippingForm />,
                stages: 1
            }
        ]
        return (<SideViewModal 
            show={visible} 
            submitText='Create Shipment'
            onSubmit={handleSubmit}
            onClose={() => {
                setErrors({ equipment: [] })
                setSubmitError(null)
                closeForm()
            }} 
            title='Shipping'
            variants={variants}
            errors={errors}
            submitError={submitError}
        />)
    }

    return null
}